
import { app } from '../app.js';
import {auth} from '../../App';
import dayjs from 'dayjs';

import { getUsers  } from "firebase/auth";
import ViewRecord from '../../main-component/ViewRecord.js';
/*const MyCustomComponent = (props) => {
    return (<div>Componente Custom {props.body}</div>);
}
const MyCustomComponent2 = (props) => {
    return (<div>Componente Custom2 {props.body}</div>);
}*/
async function afterCreateUpdateUser(collezione, data,id,viewConfig) {
    
    console.log("Chiamata funzoine afterCreateUpdateUser",collezione,data,id,viewConfig);


}
const GuideIstruttore = (props) => {
    const doc=props.docData;
    const candidatoId=props.id;
    const user=props.user;
    const collectionName="guide";
    const filters={
        "guide":{
            "istruttore":{type:'equalTo', value:candidatoId}
        }
    };
    const viewCfg="tableIstruttore";
    return (<ViewRecord 
        user={user}
        filters ={filters}
        collectionName={collectionName}
        view = {viewCfg}></ViewRecord>);
}
const obj={
    "singleLabel":"Utente",
    "label":"Utenti",
    "orderBy":"cognome",
    "onCreateCallFunction":afterCreateUpdateUser,
    "views":{
        "table":{  
            "debug":false,
            "autoLoad":true,
            "filter":false,
            //"defaultTab":"filter",
            "defaultTab":0,
            "canEditRecord":"canEditUtenteCustom",
            "canDelRecord":"canDelUtenteCustom",
            "fieldList":[
                {"field":'id', headerName:'Firebase ID', width:350 },
                
                {"field":'creation_date', headerName:'Data creazione', width:150,type:'datetime', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY HH.mm'):""), },                        
                {"field":'cognome', headerName:'Cognome', width:150,filter:{gridProp:{xs:12},match:["equalTo","startBy"] }},
                {"field":'nome', headerName:'Nome', width:150,filter:{gridProp:{xs:12},match:["equalTo","startBy"]} },
                {"field":'ruolo', headerName:'Ruolo',  width:120,filter:{gridProp:{xs:12},options:[{value:"ufficio",label:"Ufficio"}, {value:"istruttore",label:"Istruttore"}],type:'select',match:["equalTo"]} ,  valueGetter: (params) => {
                    return (app.ruoli[params.value]?app.ruoli[params.value].name:params.value);
                  }, },                      
            ], 
            "initialState":{
                columns: {
                    columnVisibilityModel: {
                        id:false
                    }
                }
            },
           /*  "customContent":{
               "pre_render_table_before_add":[
                    {
                        "Component":MyCustomComponent,
                        "props":{
                            "body":"DynText1"
                        }
                    },
                    {
                        "Component":MyCustomComponent2,
                        "props":{
                            
                            "body":"DynText2"

                        }
                    }
                ]
                
            }
            */
        },
        "update":{         
            "debug":false,     
            "fieldList":[
                
                                      
                {"field":'id', headerName:'Firebase ID', gridProp:{xs:12,sm:6},showOnNew:true, required:true, textProp:{helperText:'Inserire l\'UID preso dall\'utente Firebase'} },
                {"field":'creation_date', headerName:'Data creazione', showOnNew:true, type:'datetime',gridProp:{xs:12,sm:6}, default_function:"getCreationDatetime", textProps:{ InputProps:{readOnly: true},  disabled:true} },
                {"field":'cognome', headerName:'Cognome', gridProp:{xs:12,sm:6},  required:true},                
                {"field":'nome', headerName:'Nome', gridProp:{xs:12,sm:6} , required:true},
                {"field":'stato', headerName:'Stato', type:'select', options:[{value:1,label:"Attivo"}, {value:0,label:"Non attivo"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                
                {"field":'ruolo', headerName:'Ruolo', type:'select', options:[{value:"ufficio",label:"Ufficio"}, {value:"istruttore",label:"Istruttore"} ] , gridProp:{xs:12,sm:6}, required:true,"editable_func":"currentUserIsNotAdmin"},
                {"field":'isIstruttore', headerName:'E\' istruttore?', type:'select', options:[{value:1,label:"Si"}, {value:0,label:"No"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                
               
            ]
            
        },
        "view":{
            "addingTabs":[

                {
                    "key":"guideCandidato",
                    "label":"Guide",
                    "Component":GuideIstruttore,
                    "props":{
                        "body":""
                    }
                },
            ],
            "fieldList":[
                
                                      
                {"field":'id', headerName:'Firebase ID', gridProp:{xs:12,sm:6},showOnNew:true, required:true, textProp:{helperText:'Inserire l\'UID preso dall\'utente Firebase'} },
                {"field":'creation_date', headerName:'Data creazione', showOnNew:true, type:'datetime',gridProp:{xs:12,sm:6}, default_function:"getCreationDatetime", textProps:{ InputProps:{readOnly: true},  disabled:true} },
                {"field":'cognome', headerName:'Cognome', gridProp:{xs:12,sm:6},  required:true},                
                {"field":'nome', headerName:'Nome', gridProp:{xs:12,sm:6} , required:true},
                {"field":'stato', headerName:'Stato', type:'select', options:[{value:1,label:"Attivo"}, {value:0,label:"Non attivo"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                
                {"field":'ruolo', headerName:'Ruolo', type:'select', options:[{value:"ufficio",label:"Ufficio"}, {value:"istruttore",label:"Istruttore"} ] , gridProp:{xs:12,sm:6}, required:true,"editable_func":"currentUserIsNotAdmin"},
                {"field":'isIstruttore', headerName:'E\' istruttore?', type:'select', options:[{value:1,label:"Si"}, {value:0,label:"No"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                
               
            ]
        }
    }
};

app.collections_config["utenti"]=obj;


app.services["getFirebaseUsersSelect"]={
    "async":true,
    "func": async  function (obj) {
        if (!app.users) await loadFirebaseUsers();
        let opts=[];
        Object.keys(app.users).forEach(uid => {
            const user=app.users[uid];
            opts.push({id:uid,label:user.email+ " - "+user.providerId});
        });
        return opts;
    }
};

app.services["canEditUtenteCustom"]= {
    "async":false,
    "func": function (collezione,view,doc,permission,user) {
        if (doc.data.ruolo==="admin" && !permission.can_admin) return false;
        return true;
    }
}
app.services["canDelUtenteCustom"]= {
    "async":false,
    "func": function (collezione,view,doc,permission,user) {
        if ((doc.data.ruolo==="admin" && !permission.can_admin) || (doc.id===user.uid)) return false;
        return true;
    }
}
app.services["currentUserIsNotAdmin"]= {
    "async":false,
    "func": function (collectionName,viewConfig,gridElement,valueElements,value,activePermission,user) {
        console.log("Is editable?",valueElements);
        return valueElements.ruolo!=="admin" || !valueElements.id || valueElements.id===undefined;
    }
}
async function loadFirebaseUsers() {
    console.log("Ottengo lista utenti da FB");
    auth.listUsers()
        .then((getUsersResult) => {
            const userArray=getUsersResult.users;
            console.log("Ottenuto array",userArray);
            app.users={};
            userArray.forEach(user => {
                app.users[user.uid]=user;
            });
            console.error("Load FB Users",app.users);
        })
        .catch((error) => {
            console.error("Load FB Users Impossibile ottenere lista utenti",error);
        });

}